<template>
  <el-card class="sky-hc-card">
    <div slot="header" class="sky-hc-card__head">
      <span class="sky-hc-card__title" @click="handleGotoInnerPage">{{ category.categoryName }}</span>
      <span class="sky-hc-card__head-more" @click="handleGotoInnerPage">{{ $t('more') }}</span>
    </div>
    <ul v-for="(item, index) in data" :key="index" class="sky-hc-card__list">
      <slot>
        <li class="sky-hc-card__item" @click="handleReportArticle(item)">
          <i class="sky-hc-card__item--circle" conversionForbiddenPx2Rem="width,height" style="width:6px;height:6px" />
          <div class="sky-hc-card__item-txt-box">
            <img
              v-if="item.hot"
              src="@/assets/images/help/icon_hot.png"
              srcset="@/assets/images/help/icon_hot@2x.png"
              class="sky-hc-card__icon-hot"
            />
            <span class="sky-hc-card__item-txt">{{ item.title }}</span>
          </div>
          <!-- <span class="sky-hc-card__item-time">{{ date.format(item.updateTime, 'yyyy-MM-dd') }}</span> -->
        </li>
      </slot>
    </ul>
    <no-data v-if="!data.length" class="sky-hc-card__no-data" />
  </el-card>
</template>
<script>
import { Card } from 'element-ui'
import date from 'element-ui/lib/utils/date'

import NoData from './noData'

import { reportClick } from '@/api/help'
import { CATEGORY_TYPE } from '@/utils/enum'
export default {
  name: 'HelpCard',
  components: {
    [Card.name]: Card,
    NoData
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    category: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      date
    }
  },
  methods: {
    handleReportArticle(item) {
      reportClick({
        resourceId: item.id,
        type: CATEGORY_TYPE.ARTICLE
      })
      window.open(item.url, 'help')
    },
    handleGotoInnerPage() {
      this.$router.push({
        path: `/help/content?categoryId=${this.category.categoryId}&categoryName=${this.category.categoryName}&type=${CATEGORY_TYPE.ARTICLE}`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-card) {
  @include e(head) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 26px;
  }
  @include e(head-more) {
    font-size: $--size-base;
    color: $--color-grey-7;
    cursor: pointer;
  }
  @include e(title) {
    font-weight: bold;
    line-height: 26px;
    font-size: $--font-size-big;
    cursor: pointer;
  }

  @include e(list) {
  }
  @include e(item) {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding-left: 31px;
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;
    margin-bottom: 11px;
    align-items: center;
    height: 28px;
    @include m(circle) {
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      margin-top: -3px;
      position: absolute;
      left: 11px;
      top: 50%;
      background-image: image-set(
        url('../../../assets/styles/css_images/help/round1.png') 1x,
        url('../../../assets/styles/css_images/help/round1@2x.png') 2x
      );
      background-size: 100% 100%;
    }
  }
  @include e(item-txt-box) {
    display: flex;
    align-items: center;
    overflow: hidden;
    // margin-right: 5px;
    // white-space: nowrap;
    // word-break: break-all;
    // text-overflow: ellipsis;
  }
  @include e(item-txt) {
    font-size: $--size-base;
    line-height: 19px;
    color: $--color-grey-8;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
    text-overflow: ellipsis;
  }
  @include e(item-time) {
    font-size: $--size-base;
    line-height: 19px;
    color: rgba(0, 0, 0, 0.36);
    width: fit-content;
    flex-shrink: 0;
  }
  @include e(icon-hot) {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 3px;
    // position: absolute;
    // left: 0px;
    // top: -4px;
  }
}
</style>
<style lang="scss">
.sky-hc-card {
  .el-card__header {
    padding: 21px 0px 21px 0px;
    margin: 0px 21px;
  }
  &.el-card.is-always-shadow {
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.1);
  }
  .el-card__body {
    padding: 23px 21px 8px;
  }
}
.sky-hc-card__no-data {
  padding-bottom: 15px;
  & > img {
    width: 160px !important;
  }
}
</style>
